export default __webpack_public_path__ + "static/media/delete.2021ada2.svg";